
    import '/home/runner/work/GPT-Vis/GPT-Vis/docs/guide/custome-markdown.md?watch=parent';
    export const demoIndex = {
  ids: [],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/home/runner/work/GPT-Vis/GPT-Vis/docs/guide/custome-markdown.md?type=demo')
};